import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar.js';
import Footer from './components/Footer.js';

// Page components
import Home from './pages/Home.js';
import ServicesPage from './pages/ServicesPage.js';
import AboutPage from './pages/AboutPage.js';
import ContactPage from './pages/ContactPage.js';
import NotFoundPage from './pages/NotFoundPage.js';

// Scroll restoration component to reset the viewport to (0,0) on path transitions
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, [pathname]);

  return null;
}

export default function App() {
  return (
    <Router>
      <div className="app-shell">
        {/* Scroll helper */}
        <ScrollToTop />
        
        {/* Common Sticky Header */}
        <Navbar />
        
        {/* Multi-page Routing mappings */}
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        
        {/* Common Footer */}
        <Footer />
      </div>
    </Router>
  );
}
